
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/toaster';
import ScrollToTop from '@/components/ScrollToTop';
import ErrorBoundary from '@/components/ErrorBoundary';
import LanguageRouter from '@/components/LanguageRouter';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { AuthProvider } from '@/contexts/AuthContext';
import Home from '@/pages/Home';
import Properties from '@/pages/Properties';
import PropertyDetail from '@/pages/PropertyDetail';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import PropertyManagement from '@/pages/PropertyManagement';
import PublishProperty from '@/pages/PublishProperty';
import SearchResults from '@/pages/SearchResults';
import Login from '@/pages/Login';
import Admin from '@/pages/Admin';
import CreateProperty from '@/pages/CreateProperty';
import EditProperty from '@/pages/EditProperty';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
            <ErrorBoundary>
              <ScrollToTop />
              <Routes>
                {/* Rutas en español (por defecto, sin prefijo) */}
                <Route path="/" element={
                  <LanguageProvider>
                    <LanguageRouter />
                  </LanguageProvider>
                }>
                  <Route index element={<Home />} />
                  <Route path="propiedades" element={<Properties />} />
                  <Route path="propiedades/:title" element={<PropertyDetail />} />
                  <Route path="nosotros" element={<About />} />
                  <Route path="contacto" element={<Contact />} />
                  <Route path="gestion" element={<PropertyManagement />} />
                  <Route path="publicar" element={<PublishProperty />} />
                  <Route path="search" element={<SearchResults />} />
                </Route>

                {/* Rutas en inglés (con prefijo /en) */}
                <Route path="/en" element={
                  <LanguageProvider>
                    <LanguageRouter />
                  </LanguageProvider>
                }>
                  <Route index element={<Home />} />
                  <Route path="propiedades" element={<Properties />} />
                  <Route path="propiedades/:title" element={<PropertyDetail />} />
                  <Route path="nosotros" element={<About />} />
                  <Route path="contacto" element={<Contact />} />
                  <Route path="gestion" element={<PropertyManagement />} />
                  <Route path="publicar" element={<PublishProperty />} />
                  <Route path="search" element={<SearchResults />} />
                </Route>

                {/* Rutas de admin SIN prefijo de idioma */}
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/properties/create" element={<CreateProperty />} />
                <Route path="/admin/properties/edit/:id" element={<EditProperty />} />
              </Routes>
              <Toaster />
            </ErrorBoundary>
          </Router>
        </AuthProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
